<template>
  <div class="qianqing-blocking-record">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :col="3"
      :columns="columns"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :requestPromise="loadDataList"
      :page-size="10"
    >
      <template v-slot:lineTitle="{ text }">
        <a-tooltip :title="text">
          <div class="ellipsis-cell">{{ text }}</div>
        </a-tooltip>
      </template>
      <template v-slot:shieldTime="{ text }">
        {{ formatShieldTime(text) }}
      </template>
      <template v-slot:action="{ record }">
        <a @click="onUnblock(record)">解除屏蔽</a>
      </template>
    </StandardSearchPageView>
  </div>
</template>

<script>
import moment from 'moment'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import QianqingMixins from '@/views/resource/qianqing/mixins/QianqingMixins'

export default {
  name: 'BlockingRecordComponent',
  components: {
    StandardSearchPageView
  },
  mixins: [QianqingMixins],
  data () {
    return {
      queryParams: {
        lineId: '',
        title: '',
        shieldDateStart: undefined,
        shieldDateEnd: undefined
      },
      searchOptions: [
        {
          name: '千擎线路ID',
          key: 'lineId',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '千擎线路标题',
          key: 'title',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '屏蔽日期',
          key: 'shieldDateStart,shieldDateEnd',
          type: 'rangePicker'
        }
      ],
      columns: [
        {
          title: '千擎线路ID',
          dataIndex: 'lineId',
          width: 140
        },
        {
          title: '千擎线路标题',
          dataIndex: 'title',
          width: 480,
          scopedSlots: { customRender: 'lineTitle' }
        },
        {
          title: '屏蔽时间',
          dataIndex: 'shieldTime',
          width: 180,
          scopedSlots: { customRender: 'shieldTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    formatShieldTime (value) {
      if (!value) return ''
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value
    },
    loadDataList (params) {
      return this.getHttpServices()
        .getSourceService()
        .post('/qianqing/syncShield/list', this.buildListParams(params))
        .then(this.normalizePageResult)
    },
    onUnblock (record) {
      this.requestPost(
        '/qianqing/syncShield/unshield',
        this.buildLineParams(record),
        {
          successMsg: '解除屏蔽成功',
          failMsg: '解除屏蔽失败，请重试'
        }
      )
    }
  }
}
</script>

<style scoped lang="less">
.qianqing-blocking-record {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.ellipsis-cell {
  width: 448px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
